export default "/static-assets/_next/static/locales/pt/common.324bba4d47a10e6a56ede87d90414850.json";